import {Form, Formik} from "formik";
import React, {FC} from "react";
import clsx from "clsx";
import {CircularProgress, IconButton, makeStyles} from "@material-ui/core";
import {FormikWorkerAutoComplete} from "../../workers/sharedComponents/WorkerAutoComplete";
import * as yup from "yup";
import {useHistory} from "react-router-dom";
import {RedCloseIcon} from "../../../sharedComponents/RedCloseIcon";
import {GreenCheckIcon} from "../../../sharedComponents/GreenCheckIcon";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    autoComplete: {
        width: "100%"
    }
}));

const validationSchema = yup.object({workerId: yup.string().required("erforderlich")})

interface WorkerAssignmentFormProps {
    initialValue: string;
    assignWorker: (workerId: string) => Promise<any>;
    className?: string;
}

export const WorkerAssignmentForm: FC<WorkerAssignmentFormProps> = ({assignWorker, initialValue, className}) => {
    const classes = useStyles();
    const history = useHistory();

    const [isLoading, setIsLoading] = React.useState(false);

    const closeForm = () => history.replace({search: undefined});
    return (
        <Formik
            initialValues={{workerId: initialValue}}
            onSubmit={(values) => {
                setIsLoading(true);
                assignWorker(values.workerId)
                    .catch(() => {
                    })
                    .finally(() => {
                        setIsLoading(false);
                        closeForm();
                    })
            }}
            validationSchema={validationSchema}
        >
            {({submitForm}) => (
                <Form className={clsx(className, classes.container)}>
                    <FormikWorkerAutoComplete fullWidth name={"workerId"} className={classes.autoComplete}/>
                    {isLoading
                        ? <CircularProgress size={20} color="secondary"/>
                        : (
                            <>
                                <IconButton edge="end" onClick={closeForm}>
                                    <RedCloseIcon/>
                                </IconButton>
                                <IconButton edge="end" onClick={submitForm}>
                                    <GreenCheckIcon/>
                                </IconButton>
                            </>
                        )
                    }
                </Form>
            )}
        </Formik>
    )
};
